module.exports = __webpack_public_path__ + "static/img/banner-02.908f2470.png";